import WaveForm from './WaveForm';
import WaveFormMobile from './WaveFormMobile';
export default WaveForm;
export { WaveForm, WaveFormMobile };

export type { WaveFormMobileProps, WaveFormProps } from './IWaveForm';
